import type { TextField } from '@mui/material';
import { Autocomplete, Typography } from '@mui/material';
import React from 'react';
import { StyledTextField } from './StyledTextField';

type AutocompleteSelectProps = Omit<React.ComponentProps<typeof Autocomplete<any>>, 'renderInput'> & {
  label?: string;
  error?: boolean;
  helperText?: string;
  textFieldProps?: React.ComponentProps<typeof TextField>;
};

export const AutocompleteSelect = React.forwardRef<unknown, AutocompleteSelectProps>(({ label, error, helperText, textFieldProps, ...props }, ref) => {
  return (
    <Autocomplete
      ref={ref}
      forcePopupIcon={textFieldProps?.focused}
      renderInput={(params) => (
        <div className='flex flex-col'>
          <Typography
            variant='h3'
            className='text-label mb-2 text-sm'
          >
            {label}
          </Typography>
          <StyledTextField
            {...params}
            error={error}
            helperText={helperText}
            variant='standard'
            InputProps={{
              ...params.InputProps,
              className: `${textFieldProps?.focused ? 'py-3 pl-6' : 'pb-[0]'} duration-200 linear`,
              disableUnderline: true,
              autoComplete: 'new-password',
            }}
            InputLabelProps={{
              shrink: true,
            }}
            {...textFieldProps}
          />
        </div>
      )}
      {...props}
    />
  );
});